var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "group-collapse",
      style: { "--item-size": _vm.items.length },
    },
    _vm._l(_vm.items, function (item, index) {
      var _obj
      return _c(
        "div",
        {
          staticClass: "group-collapse-item",
          class: { selected: _vm.selected === item.key },
          style: { "z-index": _vm.items.length - index },
          on: {
            click: function ($event) {
              return _vm.select(item)
            },
          },
        },
        [
          item.iconType === "component"
            ? _c(
                "div",
                { staticClass: "group-collapse-item-icon" },
                [
                  _c(item.icon, {
                    tag: "component",
                    class: ((_obj = {}), (_obj[item.key] = true), _obj),
                  }),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "group-collapse-item-icon material-icons" },
                [_vm._v("\n            " + _vm._s(item.icon) + "\n        ")]
              ),
          _vm._v(" "),
          _c("div", { staticClass: "group-collapse-item-text" }, [
            _vm._v(_vm._s(item.text)),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }